import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { jsx as _jsx } from "react/jsx-runtime";
/*global $*/

import React from "react";
import { assert } from "@/common/assert";
import { formatImageUrl } from "@/common/utils";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
var NAMESPACED_CLICK_EVENT_NAME = "click.fht360.chatImage";

var ChatImageMessageItem =
/** @class */
function (_super) {
  __extends(ChatImageMessageItem, _super);

  function ChatImageMessageItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.myRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  ChatImageMessageItem.prototype.componentDidMount = function () {
    var _this = this;

    var el = this.myRef.current;
    assert(el, "el must be there");
    $(el).on(NAMESPACED_CLICK_EVENT_NAME, function (e) {
      return _this.onClickImageMessage(_this.props.message);
    });
  };

  ChatImageMessageItem.prototype.componentWillUnmount = function () {
    var el = this.myRef.current;
    assert(el, "el must be there");
    $(el).off(NAMESPACED_CLICK_EVENT_NAME);
  };

  ChatImageMessageItem.prototype.onClickImageMessage = function (message) {
    this.props.onClickImage(message);
    console.log("props", this.props.message.imageUrl);
  };

  ChatImageMessageItem.prototype.render = function () {
    var formatedImgUrl = formatImageUrl(this.props.message.imageUrl, ImageSizeTypeEnum.Thumbnail200whFit);
    assert(this.props.message.imageUrl, "gotta have imageurl");
    return _jsx("img", {
      src: formatedImgUrl,
      ref: this.myRef,
      className: "chat-message-item__img"
    }, void 0);
  };

  return ChatImageMessageItem;
}(React.Component);

export default ChatImageMessageItem;